'use strict';
Odigeo.defineWidget('offline_sales_banner', Odigeo.Widget.extend({
    viewClass: Odigeo.View.extend({
        pages: ['details',
            'payment',
            'results',
            'metaancillaries',
            'xsellproductselection',
            'dpresults_accommodation',
            'dpresults_flights',
            'dpresults_accommodation_details',
        ],
        slctrs: {
            template: '.offline-sales-banner-template',
            wrapper: '.offline-sales-banner-wrapper',
        },
        init: function() {
            this.opts = Odigeo.Utils.parseOptions(this.widget.options);
            this.bindEvents();
            this.update();
        },
        bindEvents: function() {
            Odigeo.bind('routeChange', Odigeo._.bind(this.update, this));
        },
        update: function() {
            this.renderize('');
            this.setTemplate();
        },
        renderize: function(content) {
            this.$el.find(this.slctrs.wrapper).html(content);
        },
        setTemplate: function() {
            var funnel = Odigeo.Utils.getFunnelInGlobalScope();
            var pageNameFromFragment = Odigeo.History.getPageNameFromFragment();
            var currentPage = Odigeo._.isEmpty(pageNameFromFragment) ? 'home' : pageNameFromFragment;
            var template = Odigeo._.template(this.$el.find(this.slctrs.template).html(), Odigeo.Utils.getTmplSettings());

            if (this.opts.tmpl !== 'home' && Odigeo._.includes(this.pages, currentPage) &&
                this.opts.translations.page[funnel][currentPage].active === 'true' &&
                !Odigeo.SessionScope.isBookingXSWhiteLabel) {
                this.renderize(template({
                    title: this.opts.translations.title,
                    charge: this.opts.translations.charge,
                    hours: this.opts.translations.hours,
                    phone: this.opts.translations.page[funnel][currentPage].phone,
                    status: this.opts.translations.status,
                }));
            } else if (currentPage === this.opts.tmpl &&
                this.opts.translations.active === 'true') {
                this.renderize(template({
                    title: this.opts.translations.title,
                    charge: this.opts.translations.charge,
                    hours: this.opts.translations.hours,
                    phone: this.opts.translations.phone,
                }));
            }
        },
    }),
}));
